import { computed, makeObservable } from 'mobx';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { getOnline } from 'src_common/common/mobx-utils/Services/getOnline';
import { Common } from 'src/domains/common/Common';
import { AutoWeakMap } from 'src_common/common/mobx-utils/AutoWeakMap';

export class NetworkConnectionState {
    public constructor(private readonly common: Common) {
        makeObservable(this);
    }

    public static get = AutoWeakMap.create((common: Common) => new NetworkConnectionState(common));

    @computed public get showOfflineMessage(): boolean {
        const configComponents = ConfigComponents.get(this.common);
        const { isNoConnectionPageVisible } = configComponents.config;
        const isOnline = getOnline();

        if (isNoConnectionPageVisible === true && isOnline === false) {
            return true;
        }

        return false;
    }
}
